import { ProjectStatusE, StatusE, UserRoleE } from "../../../models/enums";

enum FormatE {
  MXF = "mxf",
  MP4 = "mp4",
}

function checkFileFormat(
  userRole: UserRoleE,
  projectStatus: StatusE | ProjectStatusE,
  allowedFormat: string,
  file: File
) {
  const isBroadcaster = userRole === UserRoleE.Broadcaster;
  const isDownloadedByBroadcasters =
    projectStatus === StatusE.DownloadedByBroadcaster ||
    projectStatus === StatusE.DownloadedByAllBroadcasters;

  const fileFormat = file.name.split(".").pop().toLowerCase();

  return isBroadcaster || isDownloadedByBroadcasters
    ? allowedFormat !== FormatE.MXF && allowedFormat !== FormatE.MP4
    : allowedFormat !== fileFormat;
}

export default checkFileFormat;
